import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
const FallbackUserField = ({
  value,
  settingsLink
}) => {
  return /*#__PURE__*/_jsx(FormControl, {
    tooltip: I18n.text('data-token-picker.fallbackUserTooltip'),
    tooltipPlacement: "bottom right",
    label: I18n.text('data-token-picker.fallbackUserLabel'),
    help: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "data-token-picker.fallbackUserLabelHelp",
      options: {
        href: settingsLink
      }
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      "data-test-id": "global-user-fallback-input",
      disabled: true,
      value: value || ''
    })
  });
};
FallbackUserField.displayName = 'FallbackUserField';
export default FallbackUserField;